/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'

import {
    GET_REPORT_SUMMARY,
    GET_REPORT_SUMMARY_EIR,
    GET_REPORT_SUMMARY_FORECAST,
    GET_REPORT_SUMMARY_REMITTANCE,
    GET_REPORT_AGING,
    GET_REPORT_PAYIN,
    GET_REPORT_RECEIPT,
    GET_REPORT_GENERAL,
    GET_REPORT_DAILY_REPORT,
    GET_REPORT_LOANINFO,
    GET_REPORT_LOANTRACKING,
    GET_REPORT_LOAN_CLASSIFY
} from '@/queries/modules/report'

import {
    error,
} from '@/utils/notification'
export async function clearReportDatas(context, payload) {
  try {
      context.commit('setReportDatas', [])
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportSummary(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_SUMMARY,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getReportSummary: reportSummary} = data
      context.commit('setSuccess', null)
      return reportSummary;
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportSummaryEir(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_SUMMARY_EIR,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getReportSummaryEir: reportSummaryEir} = data
      context.commit('setSuccess', null)

     return reportSummaryEir;
  } catch (e) {
    // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportSummaryForecast(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_SUMMARY_FORECAST,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getReportSummaryForecast: reportSummaryForecast} = data
    context.commit('setSuccess', null)
      return reportSummaryForecast;
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportSummaryRemittance(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true);

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_SUMMARY_REMITTANCE,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getReportSummaryRemittance: reportSummaryRemittance} = data
    context.commit('setSuccess', null)

      return reportSummaryRemittance;
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportAging(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_AGING,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportAging: reportAging} = data

      context.commit('setReportDatas',  reportAging)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportPayin(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    payload: payload.form
  }
  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_PAYIN,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
      const {getReportPayin: reportPayin} = data
      context.commit('setReportDatas', reportPayin)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportReceipt(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    payload: payload.form
  }
  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_RECEIPT,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportReceipt: reportReceipt} = data

      context.commit('setReportDatas', reportReceipt)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportGeneral(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  const variables = {
    payload: payload.form
  }
  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_GENERAL,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportGeneral: reportGeneral} = data

      context.commit('setReportDatas',  reportGeneral)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportDaily(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)
  const agingNumber = payload.form.agingNumber
  delete payload.form.agingNumber
  const variables = {
    payload: payload.form
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_REPORT_DAILY_REPORT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    let { getReportDaily } = data
    let reportDaily = getReportDaily
    if(agingNumber >= 1){ reportDaily = getReportDaily.filter(res => res.agingNumber >= agingNumber) }
    context.commit('setReportDatas', reportDaily)
    context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportLoanInfo(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_LOANINFO,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportLoanInfo: reportLoanInfo} = data
      // console.log(data)
      context.commit('setReportDatas', reportLoanInfo)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportLoanTracking(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_LOANTRACKING,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportLoanTracking: reportLoanTracking} = data
      // console.log(data)
      context.commit('setReportDatas', reportLoanTracking)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}

export async function getReportLoanClassify(context, payload) {
  // console.log('Get Contracts...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    payload: payload.form
  }

  try {
      const response = await apolloClient
        .query({
          query: GET_REPORT_LOAN_CLASSIFY,
          variables,
          fetchPolicy: 'network-only'
        })
      const {data} = await response
    const {getReportLoanClassify: reportLoanClassify} = data

      // console.log(data)
      context.commit('setReportDatas', reportLoanClassify)
      context.commit('setSuccess', null)
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(e.toString(), null));
  }
}
